type UserAuthTokenPersister = (token: string | undefined) => void

let persister: UserAuthTokenPersister | undefined

export function registerUserAuthTokenPersister(next: UserAuthTokenPersister) {
  persister = next
}

export function persistUserAuthTokenFromResponse(token: string | undefined) {
  persister?.(token)
}
